import { Components, Theme } from "@mui/material/styles";

export const MuiTooltip = (theme: Theme) =>
  ({
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: theme.palette.tooltip.background,
          color: theme.palette.text.primary,
          boxShadow: theme.palette.tooltip.shadow,
        },
        arrow: {
          "&::before": {
            backgroundColor: theme.palette.tooltip.background,
            boxShadow: theme.palette.tooltip.arrowShadow,
          },
        },
      },
    },
  }) satisfies Components<Theme>;
